































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetAllData, GetTyx, GetZhenci, GetTizhiRenshu } from "@/request/home";
import echarts from "echarts";
@Component({})
export default class Show extends Vue {
  private centers: any = {};
  private nowTime = new Date();
  private curTab = "全部诊次";
  private curTizhi = 1;
  private interval: any = {};
  private curZhenciData: any = {};
  private curFenbuData: any = {};
  private diqu: any = "all";
  private imgSrc: any = "";
  private isRead: any = false;
  private tizhiArr: any = [
    "气虚体",
    "阳虚体",
    "痰湿体",
    "积滞体",
    "肝火体",
    "热盛体",
    "高敏体",
    "怯弱体",
    "健康体",
  ];
  private tabs: any = ["全部诊次", "第1次", "第2次", "第3次"];
  private data: any = {
    采集数据统计: {},
    不同区域小儿体质特征分布: {},
    各诊次体质占比分布: {},
    气虚体症状特异性分析: {},
    气虚体干预前后症状: {
      干预前: {
        title: [
          "毛发不荣",
          "面色萎黄",
          "爪甲不容",
          "多汗",
          "纳少",
          "易感冒",
          "易咳嗽",
          "腹部不适",
          "面部花斑",
          "大便少",
        ],
        data: [
          {
            title: "毛发不荣",
            value: "0.82",
          },
          {
            title: "面色萎黄",
            value: "0.91",
          },
          {
            title: "爪甲不容",
            value: "0.86",
          },
          {
            title: "多汗",
            value: "0.93",
          },
          {
            title: "纳少",
            value: "0.78",
          },
          {
            title: "易感冒",
            value: "0.92",
          },
          {
            title: "易咳嗽",
            value: "0.93",
          },
          {
            title: "腹部不适",
            value: "0.54",
          },
          {
            title: "面部花斑",
            value: "0.24",
          },
          {
            title: "大便少",
            value: "0.34",
          },
        ],
      },
      干预后: {
        title: [
          "毛发不荣",
          "面色萎黄",
          "爪甲不容",
          "多汗",
          "纳少",
          "易感冒",
          "易咳嗽",
          "腹部不适",
          "面部花斑",
          "大便少",
        ],
        data: [
          {
            title: "毛发不荣",
            value: "0.74",
          },
          {
            title: "面色萎黄",
            value: "0.46",
          },
          {
            title: "爪甲不容",
            value: "0.77",
          },
          {
            title: "多汗",
            value: "0.88",
          },
          {
            title: "纳少",
            value: "0.70",
          },
          {
            title: "易感冒",
            value: "0.81",
          },
          {
            title: "易咳嗽",
            value: "0.82",
          },
          {
            title: "腹部不适",
            value: "0.11",
          },
          {
            title: "面部花斑",
            value: "0.08",
          },
          {
            title: "大便少",
            value: "0.2",
          },
        ],
      },
    },
  };
  private zhenciOption: any = {
    color: [
      "#FF9668",
      "#8FC31F",
      "#F35833",
      "#00CCFF",
      "#FFCC01",
      "#A74FAF",
      "#4F6BED",
      "#5DE7CB",
      "#ED4F6E",
    ],
    tooltip: {
      show: true,
      trigger: "item",
      formatter: (params: any) => {
        return (
          params.data.title +
          ":" +
          params.value +
          "&emsp;" +
          (params.data.ratio * 100).toFixed(2) +
          "%"
        );
      },
    },
    series: [
      {
        type: "pie",
        // startAngle: 0,
        clockwise: false,
        data: this.curZhenciData.data,
        label: {
          show: true,
          formatter: (params: any) => {
            return (
              params.data.title +
              ":" +
              params.value +
              "(" +
              (params.data.ratio * 100).toFixed(2) +
              "%" +
              ")"
            );
          },
        },
        radius: ["0", "55%"],
        // roseType: 'area'
      },
    ],
  };
  private caijishujuOption: any = {
    grid: {
      left: "1%",
      right: "0",
      top: "8%",
      bottom: "1%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: this.data["采集数据统计"]["title"],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          rotate: 30,
          textStyle: {
            color: "#fff",
            fontSize: 10,
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        roundCap: true,
        axisLabel: {
          textStyle: {
            color: "#4F617D",
            fontSize: 10,
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        data: this.data["采集数据统计"]["data"],
        color: ["#009ECA"],
        type: "bar",
        barWidth: 20,
        itemStyle: {
          normal: {
            barBorderRadius: [10, 10, 0, 0],
          },
        },
        label: {
          show: true,
          position: "top",
          color: "#b29d34",
          fontSize: 10,
          formatter: (params: any) => {
            return params.value;
          },
        },
      },
      {
        data: this.data["采集数据统计"]["data"],
        type: "line",
      },
    ],
  };
  private qixutiOption: any = {
    title: {
      text: "气虚体",
      top: "5%",
      left: "center",
      textStyle: {
        color: "#fff",
      },
    },
    color: [
      "#0490FD",
      "#DB6153",
      "#637698",
      "#04FD60",
      "#C9C9C9",
      "#5A9BD5",
      "#FF9668",
      "#8FC31F",
      "#F35833",
      "#00CCFF",
      "#FFCC01",
      "#A74FAF",
      "#5D65E7",
      "#E75DB5",
      "#3BE5E7",
      "#E304FD",
      "#ECB976",
      "#FDFB04",
      "#FD2104",
    ],
    tooltip: {
      show: true,
      trigger: "item",
      formatter: (params: any) => {
        return (
          params.data.title +
          ":" +
          params.value +
          "&emsp;" +
          (params.data.ratio * 100).toFixed(2) +
          "%"
        );
      },
    },
    // legend: {
    //   bottom: "1%",
    //   left: "center",
    //   textStyle: {
    //     color: "#B2B8C4",
    //   },
    // },
    series: [
      {
        type: "pie",
        roseType: "area",
        radius: [20, 70],
        // center: ["25%", "50%"],
        clockwise: false,
        data: this.data["气虚体症状特异性分析"].data,
        label: {
          show: true,
          formatter: (params: any) => {
            return (
              params.data.title +
              ":" +
              params.value +
              "(" +
              (params.data.ratio * 100).toFixed(2) +
              "%" +
              ")"
            );
          },
        },
      },
    ],
  };
  private ganyuqianOption: any = {
    grid: {
      left: "8%",
      right: "0",
      top: "20%",
      bottom: "4%",
      containLabel: true,
    },
    title: {
      text: "干预前",
      top: "center",
      left: "0",
      textStyle: {
        color: "#fff",
        fontSize: 14,
      },
    },
    xAxis: [
      {
        type: "category",
        data: this.data["气虚体干预前后症状"]["干预前"]["title"],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          rotate: 30,
          textStyle: {
            color: "#fff",
            fontSize: 10,
          },
          formatter: (params: any) => {
            return params;
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        roundCap: true,
        axisLabel: {
          textStyle: {
            color: "#4F617D",
            fontSize: 10,
          },
          formatter: (params: any) => {
            return params + "%";
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        data: this.data["气虚体干预前后症状"]["干预前"]["data"],
        color: ["#009ECA"],
        type: "bar",
        barWidth: 20,
        itemStyle: {
          normal: {
            barBorderRadius: [10],
          },
        },
        label: {
          show: true,
          position: "top",
          color: "#b29d34",
          fontSize: 10,
          formatter: (params: any) => {
            return params.value;
          },
        },
      },
      {
        data: this.data["气虚体干预前后症状"]["干预前"]["data"],
        type: "line",
      },
    ],
  };
  private ganyuhouOption: any = {
    title: {
      text: "干预后",
      top: "center",
      left: "0%",
      textStyle: {
        color: "#fff",
        fontSize: 14,
      },
    },
    grid: {
      left: "8%",
      right: "0",
      top: "20%",
      bottom: "4%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: this.data["气虚体干预前后症状"]["干预后"]["title"],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          rotate: 30,
          textStyle: {
            color: "#fff",
            fontSize: 10,
          },
          formatter: (params: any) => {
            return params;
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        roundCap: true,
        axisLabel: {
          textStyle: {
            color: "#4F617D",
            fontSize: 10,
          },
          formatter: (params: any) => {
            return params + "%";
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        data: this.data["气虚体干预前后症状"]["干预后"]["data"],
        color: ["#009ECA"],
        type: "bar",
        barWidth: 20,
        itemStyle: {
          normal: {
            barBorderRadius: [10],
          },
        },
        label: {
          show: true,
          position: "top",
          color: "#b29d34",
          fontSize: 10,
          formatter: (params: any) => {
            return params.value;
          },
        },
      },
      {
        data: this.data["气虚体干预前后症状"]["干预后"]["data"],
        type: "line",
      },
    ],
  };
  private get titleLineHeight() {
    const innerHeight = window.innerHeight;
    console.log((innerHeight / 937) * 73 + "px");
    return (innerHeight / 937) * 73 + "px";
  }
  private get contentHeight() {
    const innerHeight = window.innerHeight;
    return (innerHeight / 937) * 864 + "px";
  }
  /**
   * @description 切换诊次
   */
  private changeTab(tab, i) {
    this.curTab = tab;
    if (i === 0) {
      this.curZhenciData = this.data["各诊次体质占比分布"]["all"];
      this.zhenciOption.series[0].data = this.curZhenciData.data;
    } else {
      if (this.data["各诊次体质占比分布"][i]) {
        this.curZhenciData = this.data["各诊次体质占比分布"][i];
        this.zhenciOption.series[0].data = this.curZhenciData.data;
      } else {
        this.curZhenciData = {};
        this.zhenciOption.series[0].data = [];
      }
    }
  }
  /**
   * @description 获取采集数据统计数据
   */
  private getCaijishuju() {
    const params = {
      params: {
        project_id: this.$store.state.center.project_id,
      },
    };
    GetAllData(this, params).then((res) => {
      this.data["采集数据统计"].total_content_count = res.total_content_count;
      this.data["采集数据统计"].total_patient_count = res.total_patient_count;
      this.data["采集数据统计"].title = res.age_bar.title;
      this.data["采集数据统计"].data = res.age_bar.data;
      this.caijishujuOption.xAxis[0].data = this.data["采集数据统计"]["title"];
      this.caijishujuOption.series[0].data = this.data["采集数据统计"]["data"];
      this.caijishujuOption.series[1].data = this.data["采集数据统计"]["data"];
    });
  }
  /**
   * @description 获取气虚体特异性分析数据
   */
  private getTyxData() {
    const params = {
      params: {
        project_id: this.$store.state.center.project_id,
      },
    };
    GetTyx(this, params).then((res) => {
      this.data["气虚体症状特异性分析"].title = res.title;
      this.data["气虚体症状特异性分析"].data = res.data;
      this.qixutiOption.series[0].data = this.data["气虚体症状特异性分析"].data;
    });
  }
  /**
   * @description 获取各诊次体质占比分布数据
   */
  private getZhenci() {
    const params = {
      params: {
        project_id: this.$store.state.center.project_id,
      },
    };
    GetZhenci(this, params).then((res) => {
      this.data["各诊次体质占比分布"] = res;
      this.curZhenciData = this.data["各诊次体质占比分布"].all;
      this.zhenciOption.series[0].data = this.curZhenciData.data;
    });
  }
  /**
   * @description 获取体质人数统计数据
   */
  private getTizhiRenshu() {
    const params = {
      params: {
        project_id: this.$store.state.center.project_id,
      },
    };
    GetTizhiRenshu(this, params).then((res) => {
      res.data.forEach((ele) => {
        ele.selected = false;
      });
      this.data["不同区域小儿体质特征分布"] = res;
      this.curFenbuData = this.data["不同区域小儿体质特征分布"].all;
      const Chart: any = echarts.init(this.$refs.pie as HTMLCanvasElement);
      const option = {
        color: [
          "#FF9668",
          "#8FC31F",
          "#F35833",
          "#00CCFF",
          "#FFCC01",
          "#A74FAF",
          "#4F6BED",
          "#5DE7CB",
          "#ED4F6E",
        ],
        tooltip: {
          show: true,
          trigger: "item",
          formatter: (param: any) => {
            return (
              param.data.title +
              ":" +
              param.value +
              "&emsp;" +
              (param.data.ratio * 100).toFixed(2) +
              "%"
            );
          },
        },
        series: [
          {
            type: "pie",
            // startAngle: 0,
            clockwise: false,
            // selectedOffset: 10,
            // selectedMode: "single",
            data: this.data["不同区域小儿体质特征分布"]["data"],
            label: {
              show: true,
              formatter: (param: any) => {
                return (
                  param.data.title +
                  ":" +
                  param.value +
                  "(" +
                  (param.data.ratio * 100).toFixed(2) +
                  "%" +
                  ")"
                );
              },
            },
            radius: ["0", "55%"],
            // roseType: 'area'
          },
        ],
      };
      Chart.setOption(option);
      // 点击事件
      Chart.off("click");
      Chart.on("click", (p: any) => {
        this.data["不同区域小儿体质特征分布"].data.forEach((ele) => {
          if (ele.title === p.data.title) {
            ele.selected = true;
          } else {
            ele.selected = false;
          }
        });
        console.log(this.data["不同区域小儿体质特征分布"]);
        this.curFenbuData = this.data["不同区域小儿体质特征分布"][p.data.title];
        // this.$forceUpdate();
      });
      setInterval(() => {
        if (this.curTizhi === this.tizhiArr.length) {
          this.curTizhi = 1;
        } else {
          this.curTizhi++;
        }
      }, 1000);
    });
  }
  /**
   * @description 切换区域
   */
  private changeQuyu(type) {
    this.diqu = type;
    this.curFenbuData = this.data["不同区域小儿体质特征分布"][type];
  }

  /**
   * @description 初始化
   */
  private mounted() {
    this.interval = setInterval(() => {
      this.nowTime = new Date();
    }, 1000);
    this.getCaijishuju();
    this.getTyxData();
    this.getZhenci();
    this.getTizhiRenshu();
  }
  /**
   * @description 预览照片
   */
  private readImg(src) {
    // this.isRead = true;
    // this.imgSrc = src;
    window.open(window.API_ROOT + src);
  }
}
